package components.loadingSpinner

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 13.10.22
 * Author : marcusspors
 */

import common.ECssClasses
import common.animation.loadingspinner.LoadingSpinnerAnimation
import core.AppContext
import core.enums.EImages
import core.extensions.toClassName
import core.extensions.useCoroutineScope
import csstype.ClassName
import csstype.Position
import csstype.Visibility
import csstype.rgba
import csstype.vh
import csstype.vw
import emotion.react.css
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.img
import react.useContext
import react.useEffect
import react.useState


external interface GlobalLoadingSpinnerProps : Props {
}

val GlobalLoadingSpinner = FC<GlobalLoadingSpinnerProps> { props ->

    val mContext by useContext(AppContext)
    val mLoadingSpinnerAnimation = LoadingSpinnerAnimation()
    val mScope = useCoroutineScope()

    var mStepIterator by useState(0)
    var mLoadingSpinnerTransition by useState(mLoadingSpinnerAnimation.mTransitions.first())

    useEffect(mStepIterator) {
        mScope.launch {
            delay(mLoadingSpinnerAnimation.mTransitions[mStepIterator].mDelay)
            mLoadingSpinnerTransition = mLoadingSpinnerAnimation.mTransitions[mStepIterator]
        }
    }

    useEffect(mLoadingSpinnerTransition) {
        mScope.launch {
            delay(mLoadingSpinnerTransition.mDuration)
            mLoadingSpinnerTransition.mNextState?.let {
                mStepIterator = it
            } ?: mStepIterator++
        }
    }

    div {
        css {
            visibility = if (mContext.mIsLoading) Visibility.visible else Visibility.hidden
            position = Position.relative
            backgroundColor = rgba(0, 0, 0, 0.75)
            height = 100.vh
            width = 100.vw
        }
        div {
            css(ECssClasses.LOADING_SPINNER_CONTAINER.toClassName(), ClassName("step_$mStepIterator")) {  }
            div {
                css(ECssClasses.LOADING_SPINNER_COLOR_FIELD_CONTAINER.toClassName(), ClassName("step_$mStepIterator")) {  }
                div {
                    css(
                        ECssClasses.LOADING_SPINNER_COLOR_FIELD.toClassName(),
                        ClassName("step_$mStepIterator")
                    ) { }
                }
            }
            img {
                css(ECssClasses.LOADING_SPINNER_ROLLER.toClassName(), ClassName("step_$mStepIterator")) { }
                src = EImages.LOADING_SPINNER_ROLLER.mRelativePath
            }
        }
    }

}
